import axios from "axios"
import { _throw } from "../utils/error-service"
import { API, BASIC_AUTH } from '../constants/system'

export const api_login = async (data) => {
  try {
    const res = await axios.post(`${API}/cms/login`, data, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
        'Authorization': BASIC_AUTH
      }
    })
    return res
    
  } catch (err) {
    return _throw(err)
  }
}

export const api_me = async (token) => {
  try {
    const res = await axios.get(`${API}/cms/me`, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
        'Authorization': token
      }
    })
    return res

  } catch (err) {
    return _throw(err)
  }
}

export const api_register = async (data) => {
  try {
    const res = await axios.post(`${API}/cms/register`, data, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
        'Authorization': BASIC_AUTH
      }
    })
    return res
    
  } catch (err) {
    return _throw(err)
  }
}

export const api_complete_registration = async (data, token) => {
  try {
    const res = await axios.post(`${API}/merchant`, data, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
        'Authorization': token
      }
    })
    return res
    
  } catch (err) {
    return _throw(err)
  }
}

export const api_check_invite_token = async (token) => {
  try {
    const res = await axios.post(`${API}/cms/auth/invite/${token}`, {}, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
        'Authorization': BASIC_AUTH
      }
    })
    return res
    
  } catch (err) {
    return _throw(err)
  }
}

export const api_complete_password_reset = async (token, password) => {
  try {
    const res = await axios.post(`${API}/auth/update-password`, {
      password,
      token
    }, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        'Authorization': BASIC_AUTH
      }
    })
    return res
    
  } catch (err) {
    
    return _throw(err)
  }
}